<template>
  <router-link
    class="navbar-toggler"
    v-if="blok.page.linktype=='story'"
    :to="blok.page.cached_url | formatSbInternalLink"
    v-editable="blok"
    :target="target"
  >
    <span class="toggler-icon">
      <font-awesome-icon icon="shopping-cart" size="lg"/>
      <b-badge pill variant="primary">{{ items.length }}</b-badge>
    </span>
  </router-link>
  <a class="navbar-toggler" v-else v-editable="blok" :href="url">
    <span class="toggler-icon">
      <font-awesome-icon icon="shopping-cart" size="lg"/>
      <b-badge pill variant="primary">{{ items.length }}</b-badge>
    </span>
  </a>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
    name: 'mobile-basket-button',
    props: {
        target: {
            type: String,
            required: true
        },
        blok: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState({
            meal_preferences: state => state.profile.meal_preferences,
            meal_plan: state => state.profile.meal_preferences.meal_plan,
            discount_percent: state => state.basket.discountPercent,
            items: state => state.basket.items,
            basket: state => state.basket,
        }),
        ...mapGetters({
            basketValue: 'basket/total',
            ready: "basket/ready"
        }),
        classes: function() {
            return [this.$props.blok.classes].join(" ");
        },
        value: function() {
            const f = this.$options.filters;
            const val = f.currency(f.grossAmount(f.discount(this.basketValue, this.discount_percent), 0.2),'£');
            return val;
        },
        url: function() {
          const f = this.$options.filters;
          return this.ready
            ? f.appendLegacyOnboardingQuery(
                f.formatSbInternalLink(this.blok.page.cached_url),
                this.meal_preferences,
                this.basket
              )
            : "javascript://";
        }
    }
}
</script>
